export const PAYMENT_TYPE_YANDEX = 'yandex'
export const PAYMENT_TYPE_CASH = 'cash'
export const PAYMENT_TYPE_SOCIAL = 'social'
export const PAYMENT_TYPE_BONUSES = 'bonuses'
export const PAYMENT_TYPE_EPAYMENT = 'epayment_mixed'
export const PAYMENT_TYPE_EPAYMENT_PREPAYMENT = 'epayment_tsr'
export const PAYMEN_TYPE_GPB = 'gpb'
export const PAYMENT_TYPE_GPB_SBP = 'gpb_sbp'

export const PAYMENT_METHODS: Record<
  string,
  { description: string; isCash?: boolean; disabled?: boolean }
> = {
  [PAYMENT_TYPE_YANDEX]: {
    description: 'Оплата картой',
    disabled: true
  },
  [PAYMENT_TYPE_EPAYMENT]: {
    description: 'Халык Epay (оплата после сборки)',
    disabled: false
  },
  [PAYMENT_TYPE_CASH]: {
    description: 'Оплата наличными при получении',
    isCash: true
  },
  [PAYMEN_TYPE_GPB]: {
    description: 'Газпромбанк (оплата картой)',
    disabled: false
  },
  [PAYMENT_TYPE_GPB_SBP]: {
    description: 'Газпромбанк (СБП)',
    disabled: false
  },
  [PAYMENT_TYPE_EPAYMENT_PREPAYMENT]: {
    description: 'Халык Epay (предоплата)',
    disabled: false
  }
  // [PAYMENT_TYPE_SOCIAL]: {
  //   description: 'Социальный заказ',
  //   disabled: true
  // }
}

export const DEFAULT_PAYMENT_METHOD = PAYMENT_TYPE_CASH
